export function isAndroidBotMessage({ activity, isAndroid }) {
  return Boolean(
    isAndroid &&
      activity?.type === "message" &&
      activity?.from?.role === "bot",
  );
}

export function scheduleAndroidBotScroll({
  activity,
  cancelAnimationFrame = window.cancelAnimationFrame.bind(window),
  getChatBody,
  isAndroid,
  pendingFrameId = null,
  requestAnimationFrame = window.requestAnimationFrame.bind(window),
}) {
  if (
    !isAndroidBotMessage({
      activity,
      isAndroid,
    })
  ) {
    return null;
  }

  if (pendingFrameId !== null) {
    cancelAnimationFrame(pendingFrameId);
  }

  return requestAnimationFrame(() => {
    const transcript = getChatBody()?.querySelector(
      ".webchat__basic-transcript__scrollable",
    );

    if (!transcript) {
      return;
    }

    if (typeof transcript.scrollTo === "function") {
      transcript.scrollTo({
        behavior: "smooth",
        top: transcript.scrollHeight,
      });
      return;
    }

    transcript.scrollTop = transcript.scrollHeight;
  });
}
